module.exports = "/packs/money-logo-11a099d25d8054f7d0ce1e5e77834bf1.svg";